export default __webpack_public_path__ + "static/media/soybean-icon.ada05bac.svg";